import { Flex } from '@chakra-ui/react';
import React from 'react';
import { ConfirmationDataPropTypes } from './ConfirmationDataPropTypes';
import { ConfirmationDataTable } from './ConfirmationDataTable';
import { CallToActionButton } from '../../components';
import { containerStyles, ctaButtonProps, tableStyles } from './constant';
import { displayLoader } from '../../components/payRent/Utils';

export const ConfirmationData = ({
  showAltDetails,
  ctaButtonConfigs,
  objTenant,
  unitDetails,
  isLoading,
}: ConfirmationDataPropTypes.IConfirmationDataProps) => {
  return (
    <Flex {...containerStyles}>
      {isLoading && displayLoader()}
      <Flex {...tableStyles} direction={{ base: 'column', sm: showAltDetails ? 'column' : 'row' }}>
        <ConfirmationDataTable
          showAltDetails={showAltDetails}
          ctaButtonConfigs={ctaButtonConfigs}
          objTenant={objTenant}
          unitDetails={unitDetails}
        />
      </Flex>
      <Flex {...ctaButtonProps}>
        {ctaButtonConfigs.map((ctaButtonConfig) => {
          return (
            <CallToActionButton
              {...ctaButtonConfig}
              otherButtonProps={{ width: { base: '250px', sm: '294px' }, height: '36px' }}
            />
          );
        })}
      </Flex>
    </Flex>
  );
};
